export default {
  namespaced: true,
  state: {
    contentChoosing: false,
    contentReplacing: false,
    contentTarget: null,
    contentContext: null,
    contentChosen: null,
    contentProvider: null,
    // Which of the provider's connections the picker is pointed at. Two
    // Confluence spaces are two connections of one provider, so the
    // provider alone no longer says which catalogue is open.
    contentConnection: null,
    editedNodeContent: null,
    providers: []
  },
  getters: {
    isContentChoosing(state) {
      return state.contentChoosing;
    },
    isContentReplacing(state) {
      return state.contentReplacing;
    },
    getTarget(state){
      return state.contentTarget;
    },
    getChosenContent(state){
        return state.contentChosen;
    },
    getContentProvider(state){
      return state.contentProvider
    },
    getContentConnection(state){
      return state.contentConnection
    },
    getContentContext(state){
      return state.contentContext
    },
    getEditedNodeContent(state) {
      return state.editedNodeContent
    },
    getContentProviders(state){
      return state.providers
    }
  },
  mutations: {
    SET_CHOOSING_CONTENT(state, status){
      state.contentChoosing = status;
    },
    SET_REPLACING_CONTENT(state, status){
      state.contentReplacing = status;
    },
    SET_TARGET(state, target){
      state.contentTarget = target;
    },
    SET_CONTENT_PROVIDER(state, source){
      state.contentProvider = source;
    },
    SET_CONTENT_CONNECTION(state, connection){
      state.contentConnection = connection;
    },
    SET_CONTENT_CONTEXT(state, context){
      state.contentContext = context;
    },
    SET_EDITED_NODE_CONTENT(state, node){
      state.editedNodeContent = node;
    },
    SET_CONTENT_PROVIDERS(state, providers){
      state.providers = providers
    }
  },
  actions: {
    contentChoosingSet({commit}, status){
      commit('SET_CHOOSING_CONTENT', status);
    },
    contentReplacingSet({commit}, status){
      commit('SET_REPLACING_CONTENT', status);
    },
    contentTargetSet({commit}, target){
      commit('SET_TARGET', target);
    },
    contentProviderSet({commit}, source){
      commit('SET_CONTENT_PROVIDER', source);
    },
    contentConnectionSet({commit}, connection){
      commit('SET_CONTENT_CONNECTION', connection);
    },
    contentProvidersSet({commit}, providers){
      commit('SET_CONTENT_PROVIDERS', providers);
    },
    contentContextSet({commit}, context) {
      commit('SET_CONTENT_CONTEXT', context);
    },
    contentEditedNodeSet({commit}, node){
      commit('SET_EDITED_NODE_CONTENT', node);
    }
  }
}